export const SITE_ORIGIN = 'https://theitgirlguide.com'
export const SITE_NAME = 'The It Girl Guide'
export const SITE_SHORT = 'TIGG'

export function absUrl(path: string) {
  if (/^https?:\/\//i.test(path)) return path
  const next = path.startsWith('/') ? path : `/${path}`
  if (next === '/') return `${SITE_ORIGIN}/`
  const segment = next.split('/').pop() || ''
  if (/\.[a-z0-9]+$/i.test(segment)) return `${SITE_ORIGIN}${next}`
  return `${SITE_ORIGIN}${next.endsWith('/') ? next : `${next}/`}`
}

export function clipDescription(text: string, max = 155) {
  const clean = text.replace(/\s+/g, ' ').trim()
  if (clean.length <= max) return clean
  const sliced = clean.slice(0, max)
  const sentence = sliced.match(/^.+?[.!](?=\s|$)/)
  if (sentence && sentence[0].length >= 80) return sentence[0]
  const word = sliced.replace(/\s+\S*$/, '')
  return word || sliced
}

export function htmlToText(html: string) {
  return html
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim()
}
